import React, {
  useRef,
  memo,
  useState,
  useCallback,
  useEffect,
} from "react";
import Map, {
  Marker,
  Source,
  Layer,
  NavigationControl,
  FlyToInterpolator,
  Popup,
} from "react-map-gl";
import WebMercatorViewport from "viewport-mercator-project";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import Geocoder from "react-map-gl-geocoder";
import "react-map-gl-geocoder/dist/mapbox-gl-geocoder.css";
import markerImg from "../../../Assets/Images/orange-home.png";
import pointMarker from "../../../Assets/Images/blue-pin.png";
import "mapbox-gl/dist/mapbox-gl.css";
//   import "../SearchExplorer/SearchExplorer.css";
import { useLocation, useNavigate } from "react-router-dom";
//   import MarketSummary from "../MarketSummary/MarketSummary";
import { Col, Button, Row } from "reactstrap";
import MarketProfile from "../MarketProfile/MarketProfile";
import { Filter } from "../Filters/Filter";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

//import { AddMarket } from "../Index";
import AddMarket from "../AddMarket/AddMarket";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Snackbar from "@mui/material/Snackbar";
import Clear from "@mui/icons-material/Clear";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import ConfirmationPopup from "../SavedSearch/ConfirmationPopup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableRow, TableHead } from "@mui/material";
import { Config } from "../../../Utils/Config";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";
import Skeleton from '@mui/material/Skeleton';
import Legend from "../../Common/Legend";
import ConstantData from "../../../Utils/Constant";
import { checkImpersonation } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";


const skeletonArray = Array(1).fill('');
var extp = [];
var circles = {};
var supplyExtp = [];
var supplyCircles = {};
var demandExtp = [];
var demandCircles = {};
var marketId;
var isEdit = false;
const pinStyle = {
  cursor: "pointer",
  fill: "#d00",
  stroke: "none",
};

// favSearch decalarations
var cur_addrlat, cur_addrlng, cur_addr;
var obj;
var isFav;
var stateArr;
let favToEdit = null;

let demo_lat, demo_lng;
let lat, lng, rvParksCount, ProfileId;
let summary_info;
const applyToArray = (func, array) => func.apply(Math, array);
const transitionInterpolator = new FlyToInterpolator();
export const PreviewMarketMap = memo((props) => {

  var el = document.getElementsByClassName("mapboxgl-ctrl-geocoder--button");
  const location = useLocation();
  const navigate = useNavigate();
  const [favId, setFavId] = useState(null);
  const [searchId, setSearchId] = useState(null);
  const [searchName, setSearchName] = useState(null);
  const [cursor, setCursor] = useState("pointer");
  const childRef = useRef();
  const marketRef = useRef();
  const [summaryInfo] = useState({});
  const [demo_summaryInfo, setDemo_SummaryInfo] = useState({});
  const [address, setAddress] = useState("");
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const [state, setToggle] = useState({
    rvParks: true,
    popCenter: false,
  });
  const [isLoading, setLoading] = useState(false);
  const [supplyValues, setSupplyValues] = useState({
    latitude: null,
    longitude: null,
  });
  const [summary, setSummary] = useState({
    showSummary: false,
    address: null,
    city: null,
    state: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    radius: null,
  });
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [profile, setProfile] = useState({

    showProfile: false,
    address: null,
    city: null,
    state: null,
    zipCode: null,
    latitude: null,
    longitude: null,

  });
  const [isEnabled, setEnable] = useState(true);
  const [marketCenter, setMarketCenter] = useState({ latitude: null, longitude: null })
  const [viewport, setViewPort] = useState({
    width: "100%",
    height: "100vh",
    longitude: -109.4293977,
    latitude: 47.0721469,
    zoom: 2.7,
    cursor: "pointer",
  });
  const [openMarket, setMarketButton] = useState(true);
  const [geoCoderValues, setgeoCodingData] = useState({});
  const [marketInfo, setMarketInfo] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [mapView, setMapView] = useState(true);
  const [showPins, setShowPins] = useState(true);
  const [showCircle, setShowCircle] = useState(false);
  const [showSupplyCircle, setSupplyCircle] = useState(false);
  const [showDemandCircle, setDemandCircle] = useState(false);
  const [marketSummary, setMarketSummary] = useState({});
  const mapRef = useRef();
  const geocoderContainerRef = useRef();
  const geocoderDebounceTimerRef = useRef(null);
  const latestGeocoderQueryRef = useRef("");
  const geocoderAbortControllerRef = useRef(null);
  const [stateList, setStateList] = React.useState([]);
  const [selectedPins, setSelectedPins] = useState({
    latitude: null,
    longitude: null,
    name: null,
    address: null,
    address1: null,
    city: null,
    state: null,
    country: null,
    zip: null,
    profileId: null,
  });

  let favProfileId;

  const [popupInfo, setPopupInfo] = useState(false);
  const [isSummaryLoading, setSummaryLoader] = useState(true);
  const [ismarketWizard, setMarketWizard] = useState(false);
  const [btnClose, setBtnClose] = useState(true);
  const [resetValues, resetMarketView] = useState(0);
  const [resetSupply, resetSupplyValue] = useState(0);
  const [resetDemand, resetDemandValue] = useState(0);
  const [parksData, setParksData] = useState({});
  const [rvParksData, setRvParkData] = useState({});
  const [censusData, setCensusData] = useState({});
  const [show, setPopUp] = useState(true);
  const [radius, setRadius] = useState(50);
  const [supplyRadius, setSupplyRadius] = useState(50);
  const [demandRadius, setDemandRadius] = useState(50);
  const [profileInfo, setProfileInfo] = useState({});
  const [profileDtls, setProfileDtls] = useState({});
  const [profileAddress, setProfileAddress] = useState("");
  const [profileAdd, setProfileAdd] = useState("");
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [profileLoader, setLoaderProfile] = useState(false);
  const [enableEditFilter, setEnableEditFilter] = useState(false);
  const [isShowMore, setShowMore] = React.useState(false);
  const [appliedFilterObj, setAppliedFilterObj] = React.useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  //price conversion
  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return '-';

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const setSelectedPin = (data, selection) => {

   lat = parseFloat(data.latitude);
   lng = parseFloat(data.longitude);
   ProfileId = parseFloat(data.profileId)
    setPopUp(true);
    setSelectedPins({
      ...selectedPins,
      latitude: lat,
      longitude: lng,
      name: data.name,
      address: data.Street_Address1 ? data.Street_Address1 : data.address,
      address1: data.Street_Address2 ? data.Street_Address2 : data.address1,
      city: data.city,
      state: data.state,
      country: data.country,
      profileId: data.profileId,
      zip: data.zip,
    });
    // setViewPort({
    //   ...viewport,
    //   latitude: lat,
    //   longitude: lng,
    //   zoom: 5,
    //   transitionDuration: "auto",
    //   transitionInterpolator,
    // });
    //getCircle(lat, lng, "", "1");
    //childRef.current.callOnSubmit(radius);
  };


  //calculate bounding box value for circle default adjustment
  const getBoundingValues = (points) => {
    if (points) {
      const pointsLong = points.geometry.coordinates.map((point) => point[0]);
      const pointsLat = points.geometry.coordinates.map((point) => point[1]);
      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)],
      ];
      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(cornersLongLat, {
        padding: { top: 100, bottom: 100, left: 100, right: 100 },
      });
      const { longitude, latitude, zoom } = viewport;
      setViewPort({
        ...viewport,
        latitude: latitude,
        longitude: longitude,
        zoom: zoom,
      });
    }
  };
  useEffect(() => {
  if (!geocoderContainerRef.current) return;
  const geocoder = new MapboxGeocoder({
    accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
    marker: false,
    countries: "US",
    minLength: 3,
    limit: 7,
  });
  geocoder._geocode = (query) => {
    const searchQuery = query.trim();
    latestGeocoderQueryRef.current = searchQuery;
    if (geocoderDebounceTimerRef.current) {
      clearTimeout(geocoderDebounceTimerRef.current);
    }

    if (geocoderAbortControllerRef.current) {
      geocoderAbortControllerRef.current.abort();
      geocoderAbortControllerRef.current = null;
    }
   
    if (searchQuery.length < geocoder.options.minLength) {
      return Promise.resolve();
    }

    geocoderDebounceTimerRef.current = setTimeout(async () => {
      if (latestGeocoderQueryRef.current !== searchQuery) {
        return;
      }

      const controller = new AbortController();
      geocoderAbortControllerRef.current = controller;

      try {
        const params = new URLSearchParams({
          access_token: process.env.REACT_APP_MAPBOX_TOKEN,
          autocomplete: "true",
          country: "US",
          limit: String(geocoder.options.limit || 7),
        });

        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
            searchQuery
          )}.json?${params}`,
          {
            signal: controller.signal,
          }
        );

        if (!response.ok) {
          throw new Error(
            `Mapbox geocoding request failed: ${response.status}`
          );
        }

        const result = await response.json();
       
        if (
          controller.signal.aborted ||
          geocoderAbortControllerRef.current !== controller ||
          latestGeocoderQueryRef.current !== searchQuery
        ) {
          return;
        }

        const features = (result.features || []).map((feature) => ({
          ...feature,
          _source: "mapbox",
        }));

        // Give the results back to Mapbox Geocoder
        geocoder._eventEmitter.emit("results", {
          ...result,
          features,
        });

        geocoder._typeahead.update(features);
      } catch (error) {
        if (error.name === "AbortError") {
          return;
        }

        if (latestGeocoderQueryRef.current !== searchQuery) {
          return;
        }

        console.error("Mapbox geocoding error:", error);
      } finally {
        if (geocoderAbortControllerRef.current === controller) {
          geocoderAbortControllerRef.current = null;
        }
      }
    }, 1000);

    return Promise.resolve();
  };

  geocoderContainerRef.current.appendChild(geocoder.onAdd());
 
  geocoder.on("result", (event) => {
    const [longitude, latitude] = event.result.center;

    setViewPort((currentViewport) => ({
      ...currentViewport,
      longitude,
      latitude,
      zoom: 16,
      transitionDuration: 300,
    }));

    handleResult(event);
  });

  //clenaup
  return () => {
    if (geocoderDebounceTimerRef.current) {
      clearTimeout(geocoderDebounceTimerRef.current);
      geocoderDebounceTimerRef.current = null;
    }

    if (geocoderAbortControllerRef.current) {
      geocoderAbortControllerRef.current.abort();
      geocoderAbortControllerRef.current = null;
    }

    geocoder.onRemove();
  };
}, []);
  //draw circle
  const getCircle = (lats, lngs, radi, sel) => {
    setProfile({ ...profile, showProfile: false });
    circles = {};
    let radiusCal = sel === "2" ? radi : radius;
    let lat = sel === "2" ? selectedPins.latitude : lats;
    let lng = sel === "2" ? selectedPins.longitude : lngs;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    extp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      extp.push([ey, ex]);
    }
    circles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: extp,
      },
    };
    getBoundingValues(circles);
  };

  //draw circle
  const getSupplyCircle = (sLat, sLng) => {
    supplyCircles = {};
    let radiusCal = supplyRadius;
    let lat =
      activeStep === 2 && sLat
        ? sLat
        : supplyValues.latitude
          ? supplyValues.latitude
          : selectedPins.latitude ?
            selectedPins.latitude : sLat;
    let lng =
      activeStep === 2 && sLng
        ? sLng
        : supplyValues.longitude
          ? supplyValues.longitude
          : selectedPins.longitude ?
            selectedPins.longitude :
            sLng;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    if (lat && lng) {
      // find the raidus in lat/lon
      var rlat = (radiusCal / earthsradius) * r2d;
      var rlng = rlat / Math.cos(lat * d2r);

      supplyExtp = [];
      if (dir === 1) {
        var start = 0;
        var end = points + 1;
      } else {
        var start = points + 1;
        var end = 0;
      }
      for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
        var theta = Math.PI * (i / (points / 2));
        let ey = lng + rlng * Math.cos(theta);
        let ex = lat + rlat * Math.sin(theta);
        supplyExtp.push([ey, ex]);
      }
      supplyCircles = {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: supplyExtp,
        },
      };
      getBoundingValues(supplyCircles);
    }
  };

  //draw circle
  const getDemandCircle = (sLat, sLng) => {
    demandCircles = {};
    let radiusCal = demandRadius;
    let lat = selectedPins.latitude ? selectedPins.latitude : sLat;
    let lng = selectedPins.longitude ? selectedPins.longitude : sLng;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    if (lat && lng) {
      // find the raidus in lat/lon
      var rlat = (radiusCal / earthsradius) * r2d;
      var rlng = rlat / Math.cos(lat * d2r);

      demandExtp = [];
      if (dir === 1) {
        var start = 0;
        var end = points + 1;
      } else {
        var start = points + 1;
        var end = 0;
      }
      for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
        var theta = Math.PI * (i / (points / 2));
        let ey = lng + rlng * Math.cos(theta);
        let ex = lat + rlat * Math.sin(theta);
        demandExtp.push([ey, ex]);
      }
      demandCircles = {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: demandExtp,
        },
      };
      getBoundingValues(demandCircles);
    }
  };

  //change center point on lat lng  changed
  const handleViewportChange = useCallback((newViewport) =>
    setViewPort(newViewport)
  );

  //change radius based on slider value
  const handleOnChangeRadius = (e, selection) => {
     
    let centerRadius = parseInt(e.target.value);
    if (e.target.name === "supplyRadius") {
      setSupplyRadius(centerRadius);
    } else if (e.target.name === "demandRadius") {
      setDemandRadius(centerRadius);
    } else {
      setRadius(centerRadius);
      setSupplyRadius(centerRadius);
      setDemandRadius(centerRadius);
    }
    setViewPort({ ...viewport, zoom: 7 });
    if (showCircle) {
      if (activeStep === 2) {
        getSupplyCircle("", "", centerRadius, "2");
        resetSupplyValue(Math.random());
      } else if (activeStep === 3) {
        getDemandCircle("", "", centerRadius, "2");
        resetDemandValue(Math.random());
      } else {
       
        getCircle("", "", centerRadius, "2");
        getSummary(lat, lng, centerRadius);
       
        //   childRef.current.callOnSubmit(centerRadius, "1");
      }
    }
  };

  const handleGeocoderViewportChange = useCallback(
    (newViewport) => {
      const geocoderDefaultOverrides = { transitionDuration: 300 };

      return setViewPort({
        ...newViewport,
        ...geocoderDefaultOverrides,
      });
    },
    [setViewPort]
  );

  //layer created for rv pinponts
  const layerStyle = {
    id: "point",
    type: "circle",
    paint: {
      "circle-radius": 4,
      "circle-color": ["get", "iskoa"],
    },
  };

  //layer created for rv pinponts
  const layerFrSummary = {
    id: "points",
    type: "circle",
    paint: {
      "circle-radius": 4,
      "circle-color": ["get", "iskoa"],
    },
  };

  //layer created for census pinponts
  const layerStyle1 = {
    id: "points",
    type: "circle",
    paint: {
      "circle-radius": 4,
    },
  };

  useEffect(() => {
    if (location && location.state && location.state !== null) {

      favToEdit = location && location.state && location.state !== null && location.state.prevPath === "/fav-location" ? location.state.favorite : null
      setFavId(location && location.state && location.state !== null && location.state.prevPath === "/fav-location" ? location.state.id : null);
      setSearchId(location && location.state && location.state !== null && location.state.prevPath === "/saved-search" ? location.state.id : null);
      setSearchName(location && location.state && location.state !== null && location.state.prevPath === "/saved-search" ? location.state.searchName : null);
    }
  }, [location && location.state && location.state !== null && location.state.prevPath === "/saved-search"])

  //while call edit market
  useEffect(() => {
    if (location && location.state && location.state.isFrom === "my-market") {
      setViewPort({
        ...viewport, longitude: location.state.marketInfo.longitude, latitude: location.state.marketInfo.latitude,
        zoom: 6,
      })
      setSupplyRadius(location.state.marketInfo.supplyRadius);
      setDemandRadius(location.state.marketInfo.demandRadius);
      marketId = location.state.marketInfo.id;
      isEdit = true;
      setMarketWizard(true);
      setSelectedPins({
        ...selectedPins,
        latitude: location.state.marketInfo.latitude,
        longitude: location.state.marketInfo.longitude,
        name: null,
        address: null,
        address1: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        profileId: location.state.marketInfo.profileId,
      });
      setMarketInfo({ ...marketInfo, marketName: location.state.marketInfo.marketName });
      setShowCircle(isEdit);
      circles = {};
      setProfileAddress({ ...profileAddress, profileAddress: location.state.marketInfo.address });
      setProfileAdd({ ...profileAdd, profileAdd: location.state.marketInfo.address });
      setSupplyValues({ ...supplyValues, latitude: location.state.marketInfo.latitude, longitude: location.state.marketInfo.longitude });
    }
  }, [location && location.state && location.state.isFrom === "my-market"]);

  //draw circle for asynchronous calls
  useEffect(() => {
    if (selectedPins.latitude !== null && selectedPins.longitude !== null) {
      circles = {};
      getCircle(selectedPins.latitude, selectedPins.longitude, radius, "2");
      getSummary(selectedPins.latitude, selectedPins.longitude, radius);
    }
  }, [resetValues]);

  //draw Supply circle for asynchronous calls
  useEffect(() => {
    if (selectedPins.latitude !== null && selectedPins.longitude !== null) {
      supplyCircles = {};
      getSupplyCircle();
    }
  }, [resetSupply]);

  //draw Demand circle for asynchronous calls
  useEffect(() => {
    if (selectedPins.latitude !== null && selectedPins.longitude !== null) {
      demandCircles = {};
      getDemandCircle();
    }
  }, [resetDemand]);


  useEffect(() => {
    if (favToEdit !== null && favToEdit.id !== null && searchId === null) {
      editCurrentProfileFavorite(favToEdit.id);
    }
    if (searchId !== null) {
      fetchFilters();
      return;
    }
  }, [searchId])

  //intial load
  useEffect(() => {
    getParksData();
  }, []);


  const handleResult = (data) => {

    lat = data.result.center[1];
      lng = data.result.center[0];
      getSummary(lat,lng,50);
      setAddress(data.result.place_name);
    // let splitLength = data.result.place_name.split(",");
    // setProfileInfo({});
    // setProfileDtls({});
    // setPopUp(false);
    // setAddress(data.result.place_name);
    // setSelectedPins({
    //   ...selectedPins,
    //   latitude: lat,
    //   longitude: lng,
    //   name: data.result.text,
    //   address: data.result.properties.address,
    //   address1: "",
    //   city: data.result.place_name.split(",")[splitLength.length - 3],
    //   state: data.result.place_name.split(",")[splitLength.length - 2],
    //   country: data.result.place_name.split(",")[splitLength.length - 1],
    //   zip: "",
    //   profileId: null,
    // });
    // getProfileInfo(data.result.id, lat, lng);
    // setPopUp(true);
    // setViewPort({ ...viewport, latitude: lat, longitude: lng, zoom: 7 });
    // setProfile({
    //   ...profile,
    //   showProfile: true,
    //   address: data.result.place_name,
    // });
    // setSummary({
    //   ...summary,
    //   showSummary: false,
    //   latitude: lat,
    //   longitude: lng,
    // });
    //getCircle(lat, lng, radius, "1");
    //resetMarketView(Math.random());
    //childRef.current.callOnSubmit(radius);
  };

  // get rv parks data
  const getParksData = () => {
    const newParksData = [];
    let preview=true;
        apiCommonTrigger("get",Config.API_URL+"/maps/pois/demo/",[preview])
        .then((res) => {
      // setLoading(false);
      if (res.status === 200) {
        for(let feature of res.data.features){
          newParksData.push(feature.data); 
        }
        newParksData.sort((a, b) => b.features.length - a.features.length);
        setParksData(newParksData);
      } else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  const getSummary = (lat, lng, radius) => {
     
    setLoading(true);
    lat = lat;
    lng = lng;
    clearSearchResult();
    // setLoading(true);
     let inputData={
       lat: lat,
        longi: lng,
        radius: radius,
        isdemo : true
    }
     apiCommonTrigger("post",`${Config.API_URL}/search/demo`,inputData) 
    
      .then((res) => {
        if (res.status === 200) {
          clearSearchResult();
          setLoading(false);
          // setParksData({ ...parksData, parksData: res.data.rvParks });
          setMarketSummary({
            ...marketSummary,
            marketsummary: res.data.summary,
          });
          rvParksCount = res.data.summary.rvparksinmarket;
        } else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  //clear search box results
  const clearSearchResult = () => {
    if (el && el.length !== undefined && el.length > 0) {
      el[0].click();
    }
  };

  //get details of clicked points
  const getcoordinates = (event) => {

    clearSearchResult();
    setAddress("");
    setMarketSummary({});
    setShowCircle(false);
    setRadius(50);
    let latitude = event.lngLat[1];
    let longitude = event.lngLat[0];
    if (
      event.features[0] &&
      event.features[0].layer.type === "circle" &&
      activeStep === 0
    ) {

      setProfile({ ...profile, showProfile: true });
      let profileId =
        event.features[0].properties.profileid !== undefined
          ? event.features[0].properties.profileid
          : null;
      if (activeStep === 2) {
        setSupplyValues({ ...supplyValues, latitude, longitude });
        getSupplyCircle(latitude, longitude);
      } else {
        //resetOnMarketCenter("2");
        getProfileInfo(profileId, latitude, longitude);
      }
      //resetMarketView(Math.random());
    } else {

      if (activeStep === 2) {
        setSupplyValues({ ...supplyValues, latitude, longitude });
        getSupplyCircle(latitude, longitude);
      } else if (activeStep === 0) {
        //resetOnMarketCenter("2");
        setProfile({ ...profile, showProfile: false });
        // callGeocoding(latitude, longitude);
        // getProfileInfo(null, latitude, longitude);
      }
    }
  };

  //reverse geo coding for get market center;
  const callGeocoding = async (latitude, longitude) => {
    await fetch(
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      longitude +
      "," +
      latitude +
      ".json?access_token=" +
      process.env.REACT_APP_MAPBOX_TOKEN,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setgeoCodingData({
          ...geoCoderValues,
          geoCoderValues: data.features.length > 0 ? data.features[0] : {},
        });
        setProfile({
          ...profile,
          showProfile: false,
          address:
            data.features.length > 0 ? data.features[0].place_name : null,
        });
        setProfileInfo({});
        setProfileDtls({});
        setProfileAddress({
          ...profileAddress,
          profileAddress:
            data.features.length > 0 ? data.features[0].place_name : "",
        });
        if (!summary.showSummary) {
          setProfileAdd({
            ...profileAdd,
            profileAdd:
              data.features.length > 0 ? data.features[0].place_name : "",
          });
        }
        let info = {
          latitude: latitude ? latitude : 0,
          longitude: longitude ? longitude : 0,
          name: null,
          address: null,
          address1: null,
          city: null,
          state: null,
          country: null,
          zip: null,
          profileId: null,
        };
        // to check isFav
        cur_addrlat = latitude;
        cur_addrlng = longitude;
        cur_addr = data.features.length > 0 ? data.features[0].place_name : null;
        // isfavoriteCurrentAddress(latitude, longitude,  cur_addr);
        setSelectedPin(info, "db");
        // setSummary({
        //   ...summary,
        //   showSummary: false,
        //   radius: radius,
        //   latitude: latitude,
        //   longitude: longitude,
        // });
        setPopupInfo(true);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  //close/open market summary
  const toggleBtnClose = useCallback(
    (con) => {
      setBtnClose(con);
      setMarketButton(con);
    },
    [btnClose]
  );

  const showAddMarket = useCallback(
    (show, isFrom, id) => {
       
      setMarketWizard(show);
      if (isFrom === "1") {
        resetMapChanges();
      } else {
        setProfile({
          ...profile,
          showProfile: selectedPins.profileId ? true : false,
        });
        setPopupInfo(selectedPins.profileId ? false : true);
        setSummary({ ...summary, showSummary: true });
        setSupplyCircle(false);
        setDemandCircle(false);
        setActiveStep(0);
      }
    },
    [ismarketWizard]
  );

  //get market info from add market
  const getMarketInfo = useCallback((value) => {
    setMarketInfo({ ...marketInfo, marketName: value });
  }, []);

  //get active step from add market
  const setActiveSteps = useCallback((value) => {
    setActiveStep(value);
    if (value === 2) {
      getSupplyCircle();
      setSupplyCircle(true);
      resetSupplyValue(Math.random());
    } else if (value === 3) {
      getDemandCircle();
      setDemandCircle(true);
      resetDemandValue(Math.random());
    }
    if (value === 2 || value === 3) {
      setProfile({ ...profile, showProfile: false });
      setSummary({ ...summary, showSummary: false });
      setPopupInfo(false);
    }
  }, []);

  //show market summary popup
  const toggleSummary = useCallback(
    (show) => {
      if (show) {
        setSummary((prev) => {
          return {
            ...prev,
            showSummary: show,
          };
        });
      } else {
        setSummary({
          ...summary,
          showSummary: false,
        });
        setBtnClose(show);
      }
    },
    [summary.showSummary]
  );
  //show market profile popup
  const toggleProfile = useCallback(
    (show) => {
      if (show) {
        setProfile((prev) => {
          return {
            ...prev,
            showProfile: show,
          };
        });
      } else {
        setProfile({
          ...profile,
          showProfile: false,
        });
        //setBtnClose(show);
      }
    },
    [profile.showProfile]
  );

  //market center actions
  const callMarketCenter = useCallback((lat, lng) => {

    setSummary({
      ...summary,
      showSummary: true,
      radius: radius,
    });
    setShowCircle(true);
    resetMarketView(Math.random());
    setMarketCenter({ ...marketCenter, latitude: lat, longitude: lng });
    // childRef.current.callOnSubmit(radius, "1");
  }, []);

  //for call market summary api
  useEffect(() => {
    if (showCircle) {
      localStorage.setItem("demo-token", process.env.REACT_APP_DEMO_TOKEN);
      // childRef.current.callOnSubmit(radius, "1");
    }
    if (selectedPins.profileId !== null) {
      setProfileDtls({ ...profileDtls, profileDtls: selectedPins });
    } else if (selectedPins.profileId == null) {
      setProfileAdd({ ...profileAdd, profileAdd: profileAddress && profileAddress.profileAddress ? profileAddress.profileAddress : '' });
    }
  }, [showCircle, marketCenter.latitude, marketCenter.longitude]);

  //Rest to map default
  const resetMapChanges = () => {
     
    setAddress("");
    setMarketSummary({});
    navigate(location.pathname, {});
    favToEdit = null;
    setSearchId(null);
    setSearchName(null);
    setOpenPopup(false);
    setEnable(true);
    if (el && el.length !== undefined && el.length > 0) {
      el[0].click();
    }
    isEdit = false;
    //   childRef.current.resetFil(null);
    //   childRef.current.openFilter(false);
    setAppliedFilter([]);
    // filter wont be prefilled
    setAppliedFilterObj({});
    setViewPort({
      ...viewport,
      longitude: -109.4293977,
      latitude: 47.0721469,
      zoom: 2.7,
    });
    setPopupInfo(false);
    setRadius(50);
    setSupplyRadius(50);
    setDemandRadius(50);
    setShowPins(true);
    setSummary({ ...summary, showSummary: false });
    setProfile({ ...profile, showProfile: false });
    setShowCircle(false);
    setSupplyCircle(false);
    setDemandCircle(false);
    circles = {};
    demandCircles = {};
    supplyCircles = {};
    // resetSupplyValue(Math.random());
    // resetDemandValue(Math.random());
    setActiveStep(0);
    setSelectedPins({
      ...selectedPins,
      latitude: null,
      longitude: null,
      name: null,
      address: null,
      address1: null,
      city: null,
      state: null,
      country: null,
      zip: null,
      profileId: null,
    });
    setRvParkData({});
    setMarketWizard(false);
    setMarketInfo({});
    setMarketCenter({ ...marketCenter, latitude: null, longitude: null });
  };

  // reset market market center
  const resetOnMarketCenter = (id) => {
    if (id === "1") {
      setProfile({ ...profile, showProfile: false });
    } else if (id === "2") {
      setSummary({ ...summary, showSummary: false });
      setShowCircle(false);
      setRadius(50);
      setSelectedPins({
        ...selectedPins,
        latitude: null,
        longitude: null,
        name: null,
        address: null,
        address1: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        profileId: null,
      });
      // setRvParkData({});
    } else {
      setRvParkData({});
    }
  };

  const getSummaryDetails = () => {
    summary_info = [];
    let summaryDetails = marketSummary.marketsummary;
    const excludedKeys = new Set([
      "rvparkids",
      "caucasian",
      "black",
      "hispanic",
      "others",
      "avgmaleinmarket",
      "avgfemaleinmarket",
      "asianpacific",
      'percentageofhousehold',
      "potentialcampers"
    ]);
    
    
    for (let i = 0; i < Object.keys(summaryDetails).length; i++) {

      const key = Object.keys(summaryDetails)[i].toLowerCase(); // Get and lowercase the key
      const value = Object.values(summaryDetails)[i]; // Get the value

      if (value !== null && value !== undefined && value !== "" && value !== 0 && !excludedKeys.has(key)) {

        const headerMap = {
          rvparksinmarket: "RV Parks in market",
          totalrvparksites: "Total Camping spots",
          avgpricepernight: "Average price per night",
          countofhousehold: "Households",
          marketscore: "Market Score",
          potentialcampers: "Potential Campers",
          avgsizeofpark: "Average Size Of Park",
          rvownershipinmarket: "RV Ownership in market",
          percentageofhousehold: "% Of Households that camp",
          population: "Population",
          populationdensity:" Population Density",
          regiontype: "Region Type",
          incomepercapita: "Income per capita",
          avgfuelcost: "Average Fuel Cost",
          avgage: "Average Age",
          fivetotwentyfour: "Population age from 5-24",
          twentyfivetofortyfour: "Population age from 25-44",
          fortyfivetofiftyfour: "Population age from 45-54",
          fiftyfivetoseventyfour: "Population age from 55-74",
          seventyfiveandabove: "Population age of 75 And Above"
        };
        
        // Get the key from summaryDetails, ensure it is lowercase
        const key = Object.keys(summaryDetails)[i].toLowerCase();
        
        // Use the headerMap to get the table header or default to the key itself if not found
        let tableHeader = headerMap[key] || key;
        
        
        
        let formatValue = priceConversion(Object.values(summaryDetails)[i]);

        let headerValue =
          (Object.keys(summaryDetails)[i] === "avgfuelcost" ||
            Object.keys(summaryDetails)[i] === "avgpricepernight" ||
            Object.keys(summaryDetails)[i] === "incomepercapita")
            && formatValue !== '-' ? Config.Currency + formatValue
            : Object.keys(summaryDetails)[i] === "avgsizeofpark" && formatValue !== '-'
              ? formatValue + " Acres"
              : (Object.keys(summaryDetails)[i] === "percentageofhousehold" ||
                Object.keys(summaryDetails)[i] === "avgmaleinmarket" ||
                Object.keys(summaryDetails)[i] === "avgfemaleinmarket")
                && formatValue !== '-' ? formatValue + "%"
                : formatValue;

        summary_info.push(
          <TableRow key={Object.keys}>
            <TableCell>{tableHeader}</TableCell>
            <td>{headerValue}</td>
          </TableRow>
        );
      }
    }
    return summary_info;
  };
  //Rest to default
  const resetChanges = () => {
    setViewPort({
      ...viewport,
      longitude: -109.4293977,
      latitude: 47.0721469,
      zoom: 2.7,
    });
    setRadius(50);
    setSummary({ ...summary, showSummary: false });
    setProfile({ ...profile, showProfile: false });
    setShowCircle(false);
    setSelectedPins({
      ...selectedPins,
      latitude: null,
      longitude: null,
      name: null,
      address: null,
      address1: null,
      city: null,
      state: null,
      country: null,
      zip: null,
      profileId: null,
    });
  };

  //get store profile details
  const getProfileInfo = (id, latitude, longitude) => {

    setLoaderProfile(true);
     
    lat = latitude;
    lng = longitude;

      let inputData={
      profileId: id ? parseInt(id) : null,
        latitude: id ? null : latitude,
        longitude: id ? null : longitude,
    }
     apiCommonTrigger("post",`${Config.API_URL}/rvparks/demoprofile`,inputData) 
   .then((res) => {
      if (res.status === 200) {
        let geoDetails = res.data.geodetail;
        let profile = res.data.profile;
        isFav = false;
        setProfileInfo({ ...profileInfo, profileInfo: res.data });
        setLoaderProfile(false);

        // for demographic API
        demo_lat = geoDetails && geoDetails.latitude ? geoDetails.latitude : 0;
        demo_lng = geoDetails && geoDetails.longitude ? geoDetails.longitude : 0;

        let data = {
          latitude: geoDetails && geoDetails.latitude ? geoDetails.latitude : 0,
          longitude:
            geoDetails && geoDetails.longitude ? geoDetails.longitude : 0,
          name: profile && profile.profilename ? profile.profilename : "",
          address:
            profile && profile.streetaddress1 ? profile.streetaddress1 : "",
          address1:
            profile && profile.streetaddress2 ? profile.streetaddress2 : "",
          city: profile && profile.city ? profile.city : "",
          state: profile && profile.statecode ? profile.statecode : "",
          country: profile && profile.countryname ? profile.countryname : "",
          zip: profile && profile.zipcode ? profile.zipcode : "",
          profileId: id ? parseInt(id) : null,
        };

        let addr = '';
      
        if (data.name && data.name !== null) {
          addr = data.name;
        }

        if (data.address && data.address !== null) {
          // when addr is empty,append just like tat
          if (addr === "") {
            addr = data.address;
          }
          // when addr is not empty & no comma exists, include comma
          if (addr !== "" && !data.address.startsWith(",")) {
            addr = addr + ", " + data.address;
          }
          // when addr is not empty &  comma exists, dont include comma
          if (addr !== "" && data.address.startsWith(",")) {
            addr = addr + " " +data.address;
          }
        }
        if (data.city && data.city !== null) {
          if (addr === "") {
            addr = data.city;
          }

          if (addr !== "" && !data.city.startsWith(",")) {
            addr = addr + ", " + data.city;
          }
          if (addr !== "" && data.city.startsWith(",")) {
            addr = addr + " " + data.city;
          }
        }
        if (data.state && data.state !== null) {
          if (addr === "") {
            addr = data.state;
          }

          if (addr !== "" && !data.city.startsWith(",")) {
            addr = addr + ", " + data.state;
          }
          if (addr !== "" && data.city.startsWith(",")) {
            addr = addr + " " + data.state;
          }
        }
        if (data.zip && data.zip !== null) {
          if (addr === "") {
            addr = data.zip;
          }

          if (addr !== "" && !data.zip.endsWith(",")) {
            addr = addr + ", " + data.zip;
          }
          if (addr !== "" && data.zip.endsWith(",")) {
            addr = addr + +" " + data.zip;
          }
        }
       
        // setAddress(addr);
        clearSearchResult();
        if (profile !== null) {
          setAddress(addr);
          setSelectedPin(data, "db");
        } else {
          callGeocoding(latitude, longitude);
        }
        // isfavoriteCurrentAddress(data);
      }else{
        setLoaderProfile(false);
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      setLoaderProfile(false);
      handlingCatchError(err, navigate);
    })
  };

  //snack bar open/close
  const snackHandleclose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ ...snack, snackOpen: false, snackMsg: "" });
  };

  const togglePopup = (param, id, name) => {

    if (id === undefined) return setOpenPopup(true);
    // when user clicks cancel btn 0 will pass from child
    if (id === '0') return setOpenPopup(param);
    if (id === '1') {
      saveMySearch(name);
      setOpenPopup(param);
    }
  }

  //drag markers positions
  const onMarkerDragEnd = useCallback((event) => {
    setSelectedPins({
      ...selectedPins,
      latitude: event.lngLat[1],
      longitude: event.lngLat[0],
    });
    getProfileInfo(null, event.lngLat[1], event.lngLat[0]);
  }, []);

  const purchaseMartket = () => {
    if(localStorage.getItem('impersonated') === 'true') {
      checkImpersonation();
    }else{
    if (marketSummary && marketSummary.marketsummary === undefined) {
      setSnackOpen({
        ...snack,
        snackOpen: true,
        snackMsg: 'Please select a market center point to purchase a report',
      });
      return false;
    }
    clearSearchResult();
    // setLoading(true);
    let inputData={
       "Latitude": lat,
        "Longitude": lng,
        "Radius": radius,
        "RVParksCount": rvParksCount,
        "DownloadFileName": null,
        "Remarks": null,
        "Address": address ? address : null,
        "ProfileId": ProfileId ? ProfileId : null
    }
     apiCommonTrigger("post",`${Config.API_URL}/subscription/checkoutmarket`,inputData) 
  
      .then((res) => {
        if (res.status === 200) {
          // setLoading(false);
          navigate(`/buy-market-report?sessionid=${res.data.accesskey}`);
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
    }
  }

  return (
    <div id="main">
      <div className="mapbox-maps">
        <div className="search-map">
          <p>Search for an address to preview a market before purchasing</p>
          <div ref={geocoderContainerRef} className="search-box" />
          <div className="reset-btn-map">
            <Button
              id="map-reset"
              className="reset-btn"
              onClick={resetMapChanges}
            >
              Reset
            </Button>
            <Button style={{ display: isEnabled ? 'none' : "" }} onClick={togglePopup} className="reset-btn save-search" variant="outlined"><BookmarkBorderOutlinedIcon /> Save Search </Button>
          </div>
        </div>
        {openPopup ? <ConfirmationPopup open={openPopup} togglePopup={togglePopup} title={1} searchName={searchName} /> : ""}

        <div className="map-box-section">
          {/* {appliedFilter && appliedFilter.length > 0 ? (
            <div className="appliedFilter">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                <span className="filters-label">Applied Filters:</span>
                {appliedFilter.length <= 13
                  ? appliedFilter.map((data) => {
                    let value = data.name.toLowerCase() !== 'radius' ? data.value : '';
                    if (data.name.toLowerCase() !== 'radius') {
                      if (data.name.toLowerCase() !== 'radius' && data.name.toLowerCase() === 'stateId'.toLowerCase()) {
                        value = stateList
                          .filter((obj) => obj.value === data.value)
                          .map((x) => x.label);
                      }
                      if (data.name.toLowerCase() !== 'radius' && data.name.toLowerCase() === 'internetConnectivity'.toLowerCase()) {
                        if (data.value === '1') {
                          value = 'Cable';
                        }
                        else if (data.value === '2') {
                          value = "Not Available";
                        } else if (data.value === "0") {
                          value = null;
                        } else {
                          value = "Wifi";
                        }
                      }
                      if (data.name.toLowerCase() !== 'radius' && data.name.toLowerCase() === 'internetConnectivityPayment'.toLowerCase()) {
                        if (data.value === '1') {
                          value = 'Free';
                        }
                        else if (data.value === '2') {
                          value = "Not Available";
                        } else if (data.value === "0") {
                          value = null;
                        } else {
                          value = "Paid";
                        }
                      }
                      if (
                        data.name.toLowerCase() !== 'radius' &&
                        data.name.toLowerCase() !== "InternetConnectivity".toLowerCase() &&
                        data.name.toLowerCase() !== "InternetConnectivityPayment".toLowerCase() &&
                        data.name.toLowerCase() !== "stateId".toLowerCase()
                      ) {
                        if (data.value === "1") {
                          value = "No";
                        } else if (data.value === "3") {
                          value = "Yes";
                        } else if (data.value === "0") {
                          value = null;
                        }
                      }

                      if (data.name.toLowerCase() === 'hasOwner'.toLowerCase() || data.name.toLowerCase() === 'hasManagement'.toLowerCase()) {
                        value = "Yes";
                      }
                    }

                    // let value =
                    //   data.label === "RV Park's State"
                    //     ? stateList
                    //         .filter((obj) => obj.value === data.value)
                    //         .map((x) => x.label)
                    //     : data.value;

                    return value === "" ||
                      value === null ||
                      value.length === 0 ? (
                      ""
                    ) : (
                      <Chip
                        label={`${data.label}` + `: ` + `${value}`}
                        onDelete={handleDelete(data.name)}
                      />
                    );
                  })
                  : appliedFilter.slice(0, 13).map((data) => {
                    let value = data.name.toLowerCase() !== 'radius' ? data.value : '';
                    if (data.name.toLowerCase() !== 'radius') {
                      if (data.name.toLowerCase() !== 'radius' && data.name.toLowerCase() === 'stateId'.toLowerCase()) {
                        value = stateList
                          .filter((obj) => obj.value === data.value)
                          .map((x) => x.label);
                      }
                      if (data.name.toLowerCase() !== 'radius' && data.name.toLowerCase() === 'internetConnectivity'.toLowerCase()) {
                        if (data.value === '1') {
                          value = 'Cable';
                        }
                        else if (data.value === '2') {
                          value = "Not Available";
                        } else if (data.value === "0") {
                          value = null;
                        } else {
                          value = "Wifi";
                        }
                      }
                      if (data.name.toLowerCase() === 'internetConnectivityPayment'.toLowerCase()) {
                        if (data.value === '1') {
                          value = 'Free';
                        }
                        else if (data.value === '2') {
                          value = "Not Available";
                        } else if (data.value === "0") {
                          value = null;
                        } else {
                          value = "Paid";
                        }
                      }
                      if (
                        data.name.toLowerCase() !== "InternetConnectivity".toLowerCase() &&
                        data.name.toLowerCase() !== "InternetConnectivityPayment".toLowerCase() &&
                        data.name.toLowerCase() !== "stateId".toLowerCase()
                      ) {
                        if (data.value === "1") {
                          value = "No";
                        } else if (data.value === "3") {
                          value = "Yes";
                        } else if (data.value === "0") {
                          value = null;
                        }
                      }

                      if (data.name.toLowerCase() === 'hasOwner'.toLowerCase() || data.name.toLowerCase() === 'hasManagement'.toLowerCase()) {
                        if (data.value === 'true') return value = 'Yes';
                      }

                    }

                    return value === "" ||
                      value === null ||
                      value.length === 0 ? (
                      ""
                    ) : (
                      <Chip
                        label={`${data.label}` + `: ` + `${value}`}
                        onDelete={handleDelete(data.name)}
                      />
                    );
                  })}
                {appliedFilter.length <= 13 ? (
                  ""
                ) : (
                  <div
                    onClick={() => childRef.current.openFilter(true)}
                    className="showmore-link"
                  >
                    Show More
                  </div>
                )}
              </Paper>
            </div>
          ) : (
            ""
          )}
          <Row className="position-relative m-0">
            <Col md={12} className="p-0">
              <div className="mapbox-full-width">
                <Legend legendType ={ConstantData.legendDefaultKeys} />

                <Map
                  {...viewport}
                  onClick={ismarketWizard ? null : getcoordinates}
                  ref={mapRef}
                  getCursor={(e) => "pointer"}
                  onViewportChange={handleViewportChange}
                  mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
                  mapStyle={
                    mapView
                      ? "mapbox://styles/mapbox/streets-v11"
                      : "mapbox://styles/mapbox/satellite-streets-v11"
                  }
                >
                  <Geocoder
                    mapRef={mapRef}
                    containerRef={geocoderContainerRef}
                    onViewportChange={handleGeocoderViewportChange}
                    mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
                    onResult={handleResult}
                    countries="US"
                  />
                  {/* {parksData.parksData &&
                    parksData.parksData.features.length > 0 &&
                    state.rvParks &&
                    showPins ? (
                    <Source id="1" type="geojson" data={parksData.parksData}>
                      <Layer {...layerStyle} />
                    </Source>
                  ) : null} 

              {parksData.length > 0 && parksData.map((data, index) => {
                  return (
                    <Source key={index} id={`source-${index}`} type="geojson" data={data}>
                      <Layer
                        id={`layer-${index}`}
                        type="circle"
                        source={`source-${index}`}                            
                        paint={{
                          "circle-radius": 4,
                          "circle-color": ["get", "colorcode"],
                        }}
                      />
                    </Source>
                  );
                })}

                  {rvParksData.rvParksData &&
                    rvParksData.rvParksData.features.length > 0 ? (
                    <Source
                      id="2"
                      type="geojson"
                      data={rvParksData.rvParksData}
                    >
                      <Layer {...layerFrSummary} />
                    </Source>
                  ) : null}
                  {censusData.censusData &&
                    censusData.censusData.features.length > 0 &&
                    state.popCenter ? (
                    <Source id="2" type="geojson" data={censusData.censusData}>
                      <Layer {...layerStyle1} />
                    </Source>
                  ) : null}
                  {marketCenter.latitude &&
                    marketCenter.longitude &&
                    activeStep !== 2 ? (
                    <Marker
                      longitude={marketCenter.longitude}
                      latitude={marketCenter.latitude}
                      draggable
                      onDragEnd={onMarkerDragEnd}
                    >
                      <img
                        src={markerImg}
                        alt="Market Pin"
                        height={20}
                        viewBox="0 0 24 24"
                        style={{
                          ...pinStyle,
                          transform: `translate(${-10 / 2}px,${-10}px)`,
                        }}
                        onClick={() => {
                          setProfile({
                            ...profile,
                            showProfile: selectedPins.profileId ? true : false,
                          });
                          setSummary({ ...summary, showSummary: false });
                          clearSearchResult();
                          if (selectedPins.profileId !== null) {
                            getProfileInfo(
                              selectedPins.profileId,
                              selectedPins.latitude,
                              selectedPins.longitude
                            );
                          } else {
                            callGeocoding(
                              selectedPins.latitude,
                              selectedPins.longitude
                            );
                          }
                        }}
                      ></img>
                    </Marker>) : ''}
                  {selectedPins.latitude &&
                    selectedPins.longitude &&
                    activeStep !== 2 ? (
                    <Marker
                      longitude={selectedPins.longitude}
                      latitude={selectedPins.latitude}
                      draggable
                      onDragEnd={onMarkerDragEnd}
                    >
                      {marketCenter.latitude === selectedPins.latitude && marketCenter.longitude === selectedPins.longitude ? '' :
                      <img
                        src={pointMarker}
                        alt="Marker Pin"
                        height={20}
                        viewBox="0 0 24 24"
                        style={{
                          ...pinStyle,
                          transform: `translate(${-10 / 2}px,${-10}px)`,
                        }}
                        onClick={() => {
                          setProfile({
                            ...profile,
                            showProfile: selectedPins.profileId ? true : false,
                          });
                          setSummary({ ...summary, showSummary: false });
                          clearSearchResult();
                          if (selectedPins.profileId !== null) {
                            getProfileInfo(
                              selectedPins.profileId,
                              selectedPins.latitude,
                              selectedPins.longitude
                            );
                          } else {
                            callGeocoding(
                              selectedPins.latitude,
                              selectedPins.longitude
                            );
                          }
                        }}
                      ></img>}
                    </Marker>
                  ) : activeStep === 2 ? (
                    <Marker
                      latitude={
                        supplyValues.latitude !== undefined &&
                          supplyValues.latitude
                          ? supplyValues.latitude
                          : selectedPins.latitude
                      }
                      longitude={
                        supplyValues.longitude !== undefined &&
                          supplyValues.longitude
                          ? supplyValues.longitude
                          : selectedPins.longitude
                      }
                    >
                      <img
                        src={pointMarker}
                        alt="Marker Pin"
                        height={20}
                        viewBox="0 0 24 24"
                        style={{
                          ...pinStyle,
                          transform: `translate(${-10 / 2}px,${-10}px)`,
                        }}
                        onClick={() => {
                          setProfile({ ...profile, showProfile: true });
                          setSummary({ ...summary, showSummary: false });
                          getProfileInfo(
                            selectedPins.profileId,
                            selectedPins.latitude,
                            selectedPins.longitude
                          );
                        }}
                      ></img>
                    </Marker>
                  ) : (
                    ""
                  )}


                  {(circles || resetValues) && showCircle && activeStep < 2 ? (
                    <>
                      <Source id="route" type="geojson" data={circles} />
                      <Layer
                        id="route"
                        type="line"
                        source="route"
                        layout={{
                          "line-join": "round",
                          "line-cap": "round",
                        }}
                        paint={{
                          "line-color": "#000000",
                          "line-width": 2,
                        }}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  <Source id="route1" type="geojson" data={supplyCircles} />
                  <Layer
                    type="line"
                    source="route1"
                    layout={{
                      "line-join": "round",
                      "line-cap": "round",
                      visibility: showSupplyCircle ? "visible" : "none",
                    }}
                    paint={{
                      "line-color": "#000000",
                      "line-width": 2,
                    }}
                  />
                  {/* <Layer
                      type="fill"
                      source="route1"
                      paint={{
                        "fill-color": "#00ffff",
                        "fill-opacity": 0.25,
                      }}
                      layout={{
                        visibility: showSupplyCircle ? "visible" : "none",
                      }}
                    /> 
                  <Source id="route2" type="geojson" data={demandCircles} />
                  <Layer
                    type="line"
                    source="route2"
                    layout={{
                      "line-join": "round",
                      "line-cap": "round",
                      visibility: showDemandCircle ? "visible" : "none",
                    }}
                    paint={{
                      "line-color": "#000000",
                      "line-width": 2,
                    }}
                  />
                  {/* <Layer
                      type="fill"
                      source="route2"
                      paint={{
                        "fill-color": "#F18CE2",
                        "fill-opacity": 0.25,
                      }}
                      layout={{
                        visibility: showDemandCircle ? "visible" : "none",
                      }}
                    /> 
                  <div className="zoom-plus-minus">
                    <NavigationControl showCompass={false} />
                  </div>
                  {popupInfo &&
                    selectedPins.latitude &&
                    selectedPins.longitude && (
                      <Popup
                        anchor="top"
                        longitude={selectedPins.longitude}
                        latitude={selectedPins.latitude}
                        onClose={() => setPopupInfo(false)}
                        className="info-market-popup"
                      >
                        <div className="use-address">
                          <div>

                            <p className="address-section">
                              <FmdGoodOutlinedIcon />
                              {profileInfo &&
                                profileInfo.profileInfo !== undefined &&
                                profileInfo.profileInfo.profile &&
                                profileInfo.profileInfo.profile.streetaddress1
                                ? profileInfo.profileInfo.profile.streetaddress1 + ", "
                                : profileAddress && profileAddress.profileAddress
                                  ? profileAddress.profileAddress + ", "
                                  : ""}
                              {profileInfo &&
                                profileInfo.profileInfo !== undefined &&
                                profileInfo.profileInfo.profile &&
                                profileInfo.profileInfo.profile.streetaddress2
                                ? profileInfo.profileInfo.profile.streetaddress2 + ", "
                                : ""}
                              {profileInfo &&
                                profileInfo.profileInfo !== undefined &&
                                profileInfo.profileInfo.profile &&
                                profileInfo.profileInfo.profile.city
                                ? profileInfo.profileInfo.profile.city +
                                ", "
                                : ""}
                              {profileInfo &&
                                profileInfo.profileInfo !== undefined &&
                                profileInfo.profileInfo.profile &&
                                profileInfo.profileInfo.profile.statecode
                                ? profileInfo.profileInfo.profile.statecode + " "
                                : ""}
                              {profileInfo &&
                                profileInfo.profileInfo !== undefined &&
                                profileInfo.profileInfo.profile &&
                                profileInfo.profileInfo.profile.zipcode
                                ? profileInfo.profileInfo.profile.zipcode
                                : ""}
                            </p>
                            <button
                              className="use-market"
                              onClick={() => callMarketCenter(selectedPins.latitude, selectedPins.longitude)}
                            >
                              Use as market center
                            </button>
                          </div>
                        </div>
                      </Popup>
                    )}
                </Map>
                {profile.showProfile ? (
                  <Col className="market-tabs-popup p-0">
                    <MarketProfile
                      profileData={profileInfo}
                      toggleProfile={toggleProfile}
                      callMarketCenter={callMarketCenter}
                      profileId={favProfileId}
                      id={favId}
                      loaderProfile={profileLoader}
                      {...profile}
                    />
                  </Col>
                ) : null}
              </div>
            </Col>


            {selectedPins.latitude &&
              selectedPins.longitude &&
              showCircle &&
              activeStep !== 4 &&
              activeStep !== 1 ? (
              activeStep === 0 && ismarketWizard ? (
                ""
              ) : (
                <Col className="market-distance p-0">
                  <h5>
                    {activeStep === 2
                      ? "Supply Distance"
                      : activeStep === 3
                        ? "Demand Distance"
                        : "Market Distance"}
                  </h5>
                  <div className="slider-radius">
                    <label className="radius-value">
                      {activeStep === 2
                        ? supplyRadius
                        : activeStep === 3
                          ? demandRadius
                          : radius}{" "}
                      Miles
                    </label>
                    <label
                      className="label-values"
                      style={{ marginRight: "3px" }}
                    >
                      10
                    </label>
                    <input
                      name={
                        activeStep === 2
                          ? "supplyRadius"
                          : activeStep === 3
                            ? "demandRadius"
                            : "radius"
                      }
                      type="range"
                      min={10}
                      max={ConstantData.radiusMaxCount}
                      value={
                        activeStep === 2
                          ? supplyRadius
                          : activeStep === 3
                            ? demandRadius
                            : radius
                      }
                      disabled={
                        selectedPins.latitude !== null &&
                          selectedPins.longitude !== null
                          ? false
                          : true
                      }
                      onChange={(e) => handleOnChangeRadius(e, "1")}
                      step={1}
                    />{" "}
                    <label className="label-values">{ConstantData.radiusMaxCount}</label>
                  </div>
                </Col>
              )
            ) : (
              ""
            )} */}
            <Row className="m-0">
            <div className="add-market-wizard" style={{zIndex:0}}>
              {/* <ReactPlaceholder type="text" rows={7} ready={!isLoading}> */}
              <TableContainer className="table-design">
                <p className="selected-miles"> {marketSummary && marketSummary.marketsummary !== undefined && address && address !== "" ? <>You are searching for <b>{radius} miles around {address}</b></> : ""}</p>
                <Table>
                     
                          <TableBody>
                          <TableRow>
                          <TableCell>RV Parks in market</TableCell>
                          <TableCell>{isLoading?(<Skeleton/>):marketSummary && marketSummary.marketsummary !== undefined && marketSummary.marketsummary.rvparksinmarket !== null ? priceConversion(marketSummary.marketsummary.rvparksinmarket) : "-"}</TableCell>
                          </TableRow>
                          <TableRow>
                          <TableCell>Total Camping spots</TableCell>
                          <TableCell>{isLoading?(<Skeleton/>):marketSummary && marketSummary.marketsummary !== undefined && marketSummary.marketsummary.totalrvparksites !== null ? priceConversion(marketSummary.marketsummary.totalrvparksites) : "-"}</TableCell>
                          </TableRow>
                          <TableRow>
                          <TableCell>Average price per night</TableCell>
                          <TableCell>{isLoading?(<Skeleton/>):marketSummary && marketSummary.marketsummary !== undefined && marketSummary.marketsummary.avgpricepernight !== null ? `$${marketSummary.marketsummary.avgpricepernight}` : "-"}</TableCell>
                          </TableRow>
                          <TableRow>
                          <TableCell>Population</TableCell>
                          <TableCell>{isLoading?(<Skeleton/>):marketSummary && marketSummary.marketsummary !== undefined && marketSummary.marketsummary.population !== null ? priceConversion(marketSummary.marketsummary.population) : "-"}</TableCell>
                          </TableRow>
                          <TableRow>
                          <TableCell>Population Density</TableCell>
                          <TableCell>{isLoading?(<Skeleton/>):marketSummary && marketSummary.marketsummary !== undefined && marketSummary.marketsummary.populationdensity !== null ? priceConversion(marketSummary.marketsummary.populationdensity) : "-"}</TableCell>
                          </TableRow>
                          <TableRow>
                          <TableCell>Region Type</TableCell>
                          <TableCell>{isLoading?(<Skeleton/>):marketSummary && marketSummary.marketsummary !== undefined && marketSummary.marketsummary.regiontype !== null ? marketSummary.marketsummary.regiontype : "-"}</TableCell>
                        </TableRow>
                          </TableBody>
                       
                </Table>
              </TableContainer>
              {marketSummary && marketSummary.marketsummary !== undefined && marketSummary.marketsummary.population !== null &&<button
                className="use-market"
                onClick={() => purchaseMartket()}
              >
                <ShoppingCartIcon /> Confirm and Buy Market
                </button>}
              
            </div>

            {ismarketWizard && activeStep > 1 && activeStep < 4 ? (
              <Col className="market-center-popup p-0">
                <div className="market-summary-title">
                  <h5>Market Center </h5>
                </div>
                <p className="address-section">
                  {/* <FmdGoodOutlinedIcon /> */}
                  <span> {radius ? `${activeStep === 2
                    ? supplyRadius
                    : activeStep === 3
                      ? demandRadius
                      : radius} miles radius around ` : ""}</span>
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.streetaddress1
                    ? profileInfo.profileInfo.profile.streetaddress1
                    : profileAddress && profileAddress.profileAddress
                      ? profileAddress.profileAddress
                      : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.streetaddress2
                    ? ", " + profileInfo.profileInfo.profile.streetaddress2
                    : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.city
                    ? ", " + profileInfo.profileInfo.profile.city + ", "
                    : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.statecode
                    ? profileInfo.profileInfo.profile.statecode + " "
                    : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.zipcode
                    ? profileInfo.profileInfo.profile.zipcode
                    : ""}
                </p>
                <div className="map-legends">
                  <label
                    className="mapcheckboxhead"
                    style={{ marginTop: "0.5rem" }}
                  >
                    Legend
                  </label>
                  <div className="set-miles">
                    {activeStep > 1 ? (
                      <>
                        <span className="green-line"></span> Supply Distance
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="set-miles">
                    {activeStep > 2 ? (
                      <>
                        <span className="black-line"></span> Demand Distance
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
            ) : (
              ""
            )}

            {ismarketWizard ? (
              <AddMarket
                showAddMarket={showAddMarket}
                getMarketInfo={getMarketInfo}
                setActiveStep={setActiveSteps}
                profileData={profileInfo}
                address={profileAddress.profileAddress}
                marketName={marketInfo && marketInfo.marketName ? marketInfo.marketName : ""}
                supplyRadius={supplyRadius}
                demandRadius={demandRadius}
                centerRadius={radius}
                latitude={selectedPins.latitude}
                longitude={selectedPins.longitude}
                summaryData={summaryInfo}
                isEdit={isEdit}
                marketId={marketId}
              />
            ) : null}
          </Row>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snack.snackOpen}
          id="snack-success"
          className="snack-bar"
          maxsnack={3}
          autoHideDuration={5000}
          onClose={snackHandleclose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{snack.snackMsg}</span>}
          action={[
            <Clear
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={snackHandleclose}
            />,
          ]}
        />
      </div >
    </div >
  );
});

